module.exports = __webpack_public_path__ + "static/media/heroimage_igib-006.8cbdb210.jpg";